<!--
 * @Author: your name
 * @Date: 2021-03-11 16:03:34
 * @LastEditTime: 2021-03-29 17:47:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \mooklook_phone\src\views\BrandNews.vue
-->

<template>
  <div class="brandNews">
    <div :style="{minHeight:height+'px'}">
    <el-row class="brand_news">
      <el-col :span="24" v-for="(item,index) in articleList" :key="index" >
        <div class="news_left fl" @click="goDetaile(item)">
          <img class="auto-img" :src="item.imageThumbUrl" />
        </div>
        <div class="news_right fr" @click="goDetaile(item)">
          <div class="title">{{item.title}}</div>
          <div class="subtitle">{{item.description}}</div>
          <div class="go_detaile" >
            详情
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-pagination
      v-if="articleList.length>0"
      small
      layout="prev, pager, next"
      :total="searchTotal"
      @current-change="loadGoodsData"
    ></el-pagination>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import { getClassifyList, getArticleList } from "@/api/api";
import Footer from "@/components/Footer";
export default {
  name: "BrandNews",
  components: { Footer },
  // 定义属性
  data() {
    return {
      height:0,
      productData: "",
      searchTotal: 0,
      articleList:[],
      isPhone: document.body.clientWidth < 920,
    };
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 根据分类获取商品
    getClassifyList(min = 1, max = 6) {
      // 通过产品类别Id获取对应的产品列表
      let params = {
        productCategoryId: 44,
        pageIndex: min,
        pageSize: max,
      };
      getClassifyList(params)
        .then((res) => {
          if (res.data.code == 0) {
            this.productData = res.data.data.data;
            this.searchTotal =
              res.data.data.total <= 6
                ? 1 * 10
                : (parseInt(res.data.data.total / 6) + 1) * 10;
          }
        })
        .catch((err) => {
          this.poster = [];
          this.productData = "";
        });
    },
    getArticleList(min = 1, max = 6) {
      let params = {
        articleTypeId: this.lange == "Ch"?40:46,
        pageIndex: min,
        pageSize: max,
      };
      getArticleList(params).then((res) => {
        this.articleList = res.data.data.data
      });
    },
    goDetaile(item) {
      this.$router.push({name:"ArticleDetail",query:{id:item.id,title:item.title,content:JSON.stringify(item.articleContent)}})
    },
    // 分页加载数据
    loadGoodsData(page) {
      let min = page;
      this.getClassifyList(min);
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getClassifyList();
    this.getArticleList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
     let height = this.isPhone ? 233 : 427;
    this.height = window.screen.availHeight - height;
  },

};
</script>

<style lang='less' scoped>
.brand_news {
  .el-col {
    overflow: hidden;
    .news_right {
      position: relative;
      height: 100%;
      .go_detaile {
        position: absolute;
        color: #876d4b;

        cursor: pointer;
        i {
          font-weight: bold;
        }
      }
      .title {
        font-weight: bold;
        color: #3e3a39;
      }
      .subtitle {
        font-weight: 400;
        color: #878787;
      }
    }
  }
}
.el-pagination {
  display: flex;
  justify-content: center;
  /deep/.btn-next:hover,
  /deep/.btn-prev:hover {
    color: #876d4b !important;
  }
  /deep/.el-pager {
    li {
      color: #212121 !important;
    }

    li.active,
    li:hover {
      color: #876d4b !important;
    }
  }
}
</style>
